import React, { useRef, useEffect } from 'react';
import video from '../../assets/poolWater-video-web.webm';

const ServiceTech = () => {
    const videoRef = useRef(null);

    useEffect(() => {
        const videoEl = videoRef.current;

        const tryPlayVideo = () => {
            if (!videoEl) return;

            // Only call play if it's paused or ended
            if (videoEl.paused || videoEl.ended) {
                videoEl.play().catch((err) => {
                    // Handle silent failure (iOS sometimes rejects auto-play)
                    console.warn("Video play blocked or failed:", err);
                });
            }
        };

        const eventTypes = ['touchstart', 'click', 'scroll', 'mousemove'];

        // Add event listeners
        eventTypes.forEach(event => {
            window.addEventListener(event, tryPlayVideo, { passive: true });
        });

        // Add a manual loop fallback
        const handleEnded = () => {
            videoEl.currentTime = 0;
            videoEl.play().catch(() => {});
        };
        videoEl.addEventListener('ended', handleEnded);

        return () => {
            eventTypes.forEach(event => {
                window.removeEventListener(event, tryPlayVideo);
            });
            videoEl.removeEventListener('ended', handleEnded);
        };
    }, []);

    return (
        <div className='service-tech'>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <video
                            ref={videoRef}
                            muted
                            playsInline
                            preload="auto"
                            width="100%"
                            className='video-brain'
                            loading="lazy"
                        >
                            <source src={video} type="video/webm" />
                            Your browser does not support the video tag.
                        </video>
                        <div className='brain-div'>
                            <h4 className='videoHead'>Smarter Than Any Pool Shop or Service Tech</h4>
                            <p className='videoPera'>Your Pool. Fixed by AI.</p>
                            <ul className='videoUl'>
                                <li>Trained on 140,000+ pools — personalised to yours</li>
                                <li>Solves 99% of water and equipment issues</li>
                                <li>Tells you exactly which chemicals to add</li>
                                <li>Flags leaks. Helps when you're stuck!</li>
                            </ul>
                            <p className='videoPera'>No stress. No guesswork. Just results.</p>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <button className='btn btn-video landing-slider-button'>
                                TEST. TREAT. SWIM—START YOUR FREE TRIAL TODAY
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceTech;